import * as React from 'react';
import { Card } from '@fluentui/react-components';

const NotificationList: React.FC = () => (
  <Card>
    <h3>Notification List</h3>
    <div>List of notifications goes here.</div>
  </Card>
);

export default NotificationList;
